<template>
    <div>
        <el-table :data="counters" stripe border :showHeader="false" style="width: 100%">
            <el-table-column prop="label" width="150"> </el-table-column>
            <el-table-column>
                <template #default="scope">
                    {{ $l10n.__('Type') + ' : ' + scope.row.exemple }}
                </template>
            </el-table-column>
            <el-table-column width="180">
                <template #default="scope">
                    <div class="aright">
                        <CompassButton
                            :label="$t.__('common.actions.edit')"
                            type="secondary"
                            @click="spawnDialog(scope.row.id, scope.row.label)"
                        />
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <counter-form
            v-if="dialogVisible && counterStep == ''"
            :counterId="counterId"
            :glues="glues"
            :dateFormats="dateFormats"
            :identStyles="identStyles"
            :label="counterLabel"
            @close-popup="closeDialog"
        />

        <counter-draft-form
            v-if="dialogVisible && counterStep == 'draft'"
            :counterId="counterId"
            :glues="glues"
            :identStyles="identStyles"
            :label="counterLabel"
            @close-popup="closeDialog"
        />
    </div>
</template>

<script>
import CounterForm from './CounterForm.vue';
import CounterDraftForm from './CounterDraftForm.vue';

export default {
    components: {
        CounterForm,
        CounterDraftForm,
    },
    props: {
        defaultCounters: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            dialogVisible: false,
            counterId: 0,
            counterStep: '',
            counterLabel: '',
            counters: this.defaultCounters,

            listLoaded: false,
            glues: [],
            dateFormats: [],
            identStyles: [],
        };
    },
    methods: {
        spawnDialog: function (id, label) {
            this.dialogVisible = true;
            this.counterId = parseInt(id);
            this.counterLabel = label;

            const counter = this.counters.find((c) => c.id == id);
            if ('step' in counter) {
                this.counterStep = counter.step;
            }

            this.loadList();
        },
        loadList: function () {
            if (this.listLoaded) {
                return;
            }
            this.$ajax.get('/rest/documents/counter-settings', {}, (data) => {
                this.glues = data.glues;
                this.dateFormats = data.dateFormats;
                this.identStyles = data.identStyles;
                this.listLoaded = true;
            });
        },
        closeDialog: function (counter) {
            if (counter != null) {
                this.counters = this.counters.map((oldCounter) => {
                    return counter.id == oldCounter.id ? { ...oldCounter, ...counter } : oldCounter;
                });
            }

            this.dialogVisible = false;
            this.counterStep = '';
            this.counterId = 0;
            this.counterLabel = '';
        },
        sortCounter: function (counters) {
            const order = {
                estimate: 1,
                invoice: 2,
                creditnote: 3,
                order: 4,
                delivery: 5,
                proforma: 6,
            };

            return counters.sort((a, b) => {
                return order[a.doctype] < order[b.doctype];
            });
        },
    },
};
</script>
